import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as Actions from '../../../store/actions';
import {API, BASE_URL} from "../../../config";
//import {Button, Icon, IconButton, Table, TableBody, TableCell, TableHead, TableRow, TextField} from "@material-ui/core";
import {Button, Icon, IconButton} from "@material-ui/core";
import {withContext} from "../../../yeffect/StateProvider";
import ContentDrawer from "../../../yeffect/drawerWrapper";
import OpenFileRequest from "./components/openFileRequest";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import {Grid, TableFilterRow, TableHeaderRow, Table, PagingPanel} from "@devexpress/dx-react-grid-material-ui";
import {FilteringState, IntegratedFiltering, IntegratedSorting, SortingState, TableColumnResizing, PagingState, IntegratedPaging} from "@devexpress/dx-react-grid";

import Util from "../../../yeffect/utils";
const m = require('moment-timezone');

const fileRequest = API.service('file-request');

const styles = theme => ({
  layoutRoot: {},
});

class fileRequests extends Component {
  state = {
    fileRequests: false,
    debug: true,
    drawerContent: false,
    drawerWidth:'50vw',
    columnWidths: [
      { columnName: 'description', width:500},
      { columnName: 'type', width:250},
      { columnName: 'multifile', width:120},
      { columnName: 'active', width:120},
      { columnName: 'createdAt', width:120},
      { columnName: 'expiry', width:120},
      { columnName: 'expired', width:120},
      { columnName: 'URL', width:120},
      { columnName: 'Actions', width:120},
    ],
    pageSizes: [20,50, 100, 200, 0],
  };


  componentDidMount() {

    const controller = this;

    fileRequest.find().then(x => {
      controller.setState({
        fileRequests: x.data
      })
    })
  }

  changeColumnWidths = (columnWidths) => {
    this.setState({ columnWidths });
  };

  openDrawer = (fileRequest) => {
    this.setState({
      drawerContent:(<OpenFileRequest fileRequest={fileRequest} requests={this.state.fileRequests} closeDrawer={this.closeDrawer}/>),
      drawerWidth:this.state.drawerWidth,
    })
  }

  closeDrawer = () => {
    fileRequest.find().then(x => {
      this.setState({
        fileRequests: x.data,
        drawerContent:false,
      })
    })
  }

  copyToClipBoard = (url) => {
    navigator.clipboard.writeText(url)
        .then(() => {
          this.props.showMessage({
            message: 'Link Copied to Clipboard',
            variant:'success',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            }
          })
        })
        .catch(err => {
          this.props.showMessage({
            message: 'Link could not be copied.',
            variant:'error',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right'
            }
          });
        });
  }

  render()
  {
    const {classes} = this.props;

    return (
        <FusePageSimple
            classes={{
              root: classes.layoutRoot
            }}
            header={
              <Toolbar className={'flex w-full'}>
                <div className={'flex-1 flex-grow'}>
                  <Typography variant="title" color="inherit">
                    <h3>File Requests</h3>
                  </Typography>
                </div>
                  <Button type="button"
                          variant="contained"
                          color="secondary"
                          className="mx-auto normal-case"
                          aria-label="LOGIN"
                          onClick={() => this.openDrawer({})}
                          value="firebase">New File Request
                  </Button>
              </Toolbar>
            }
            content={
              <div className="p-12">
                {(this.state.fileRequests !== false) &&
                <Grid
                    rows={this.state.fileRequests}
                    columns={[
                      {name: 'description', title: 'Description'},
                      {name: 'type', title: 'type', getCellValue: row => (Util.toTitleCase(row.type))},
                      {name: 'multifile', title: 'Multi-File', getCellValue: row => (row.multifile) ? <Icon>check</Icon>  : <Icon>clear</Icon>},
                      {name: 'active', title: 'Active', getCellValue: row => (row.active && m(row.expiry).endOf('day').diff(m()) >= 0 ) ? <Icon>check</Icon>  : <Icon>clear</Icon> },
                      {name: 'createdAt', title: 'Created At', getCellValue: row => m(row.createdAt).format('YYYY-MM-DD')},
                      {name: 'expiry', title: 'Expiry', getCellValue: row => m(row.expiry).format('YYYY-MM-DD')},
                      {name: 'expired', title: 'Expired', getCellValue: row => (m(row.expiry).endOf('day').diff(m()) < 0) ? <Icon>check</Icon>  : <Icon>clear</Icon>},
                      {name: 'URL', title: 'URL', getCellValue: row => (<span><IconButton onClick={()=>this.copyToClipBoard(BASE_URL+"/upload_file_request/"+row.request_uuid)} ><Icon>content_copy</Icon></IconButton> <IconButton href={BASE_URL+"/upload_file_request/"+row.request_uuid} target={'_blank'}><Icon>open_in_new</Icon></IconButton></span>)},
                      {name: 'Actions', title: 'Actions', getCellValue: row => (<Button variant="outlined" color="primary" onClick={() => this.openDrawer(row)}>View</Button>)},
                    ]}>
                  <SortingState
                      defaultSorting={[{columnName: 'createdAt', direction: 'desc'}]}
                  />
                  <IntegratedSorting/>
                  <FilteringState defaultFilters={[]}/>
                  <IntegratedFiltering/>
                  <PagingState
                      defaultCurrentPage={0}
                      defaultPageSize={20}
                  />
                  <IntegratedPaging/>
                  <Table/>
                  <TableColumnResizing defaultColumnWidths={this.state.columnWidths}/>
                  <TableHeaderRow showSortingControls/>
                  <TableFilterRow/>
                  <PagingPanel
                      pageSizes={this.state.pageSizes}
                  />
                </Grid>
                }

                {(this.state.drawerContent !== false) &&
                  <ContentDrawer drawerContent={this.state.drawerContent} drawerWidth={'80vw'} onClose={this.closeDrawer}/>
                }


                {(this.state.debug) &&
                    <div>
                      {this.props.context.drawerContent}
                    </div>
                }
              </div>
            }
        />
    )
  }
}

function mapDispatchToProps(dispatch)
{
  return bindActionCreators({
    showMessage: Actions.showMessage,
    hideMessage: Actions.hideMessage
  }, dispatch);
}

function mapStateToProps({fuse, auth})
{
  return {
    login   : auth.login,
    user    : auth.user
  }
}

export default withContext(withStyles(styles, {withTheme: true})(connect(mapStateToProps,mapDispatchToProps)(fileRequests)));



// WEBPACK FOOTER //
// ./src/main/content/fileRequest/FileRequest.js